import { css } from 'emotion';

export const moduleBorderStyle = css`
    border: 1px solid #dbdae3;
    border-radius: 5px;
`;
